"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ERC20_SYMBOL_DECIMALS_ABI = exports.ERC20_SYMBOL_BYTES32_ABI = exports.ETH = void 0;
var ETH = "0x0000000000000000000000000000000000000000";
exports.ETH = "0x0000000000000000000000000000000000000000";
var ERC20_SYMBOL_BYTES32_ABI = ["function symbol() public view returns (bytes32)"];
exports.ERC20_SYMBOL_BYTES32_ABI = ERC20_SYMBOL_BYTES32_ABI;
var ERC20_SYMBOL_DECIMALS_ABI = ["function decimals() public view returns (uint8)", "function symbol() public view returns (string)"];
exports.ERC20_SYMBOL_DECIMALS_ABI = ERC20_SYMBOL_DECIMALS_ABI;